import { HttpEvent, HttpHandler, HttpHeaders, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable()
export class AssetTeamInterceptor implements HttpInterceptor {

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const headerSettings: { [name: string]: string | string[]; } = {};

    for (const key of request.headers.keys()) {
      headerSettings[key] = request.headers.getAll(key);
    }

    // Get the AssetTeamId from session storage, else default to '3' => PAT (Permian Asset Team)
    const assetTeamId = sessionStorage.getItem('selected-assetTeam-id') ?? '3';
    headerSettings['asset-team-id'] = assetTeamId;

    const newHeader = new HttpHeaders(headerSettings);
    request = request.clone({ headers: newHeader });

    return next.handle(request);
  }
}